import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import PersonIcon from "@mui/icons-material/Person";
import LoginIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Logout";
import { Stack } from "@mui/system";
import { CalendarMonth } from "@mui/icons-material";
import calculateNumberOfNights from "../../utils/hooks/calculateNumberOfNights";

const formatBookingDates = (startDate, endDate) => {
  const options = { day: "numeric", month: "short", year: "numeric" };
  const formattedStart =
    startDate.toLocaleString("it-IT", options).split(" ")[0] +
    " " +
    startDate.toLocaleString("it-IT", { month: "short" });
  const formattedEnd =
    endDate.toLocaleString("it-IT", options).split(" ")[0] +
    " " +
    endDate.toLocaleString("it-IT", { month: "short" });
  return `${formattedStart} - ${formattedEnd} ${endDate.getFullYear()}`;
};
const getRoomTitle = (room) => {
  if (room === "room1") return "Inno al Re";
  if (room === "room2") return "Il Barbiere Di Siviglia";
  if (room === "room3") return "L'Osteria Di Marechiaro";
  if (room === "room4") return "La Molinara";
  if (room === "room5") return "Il Matrimonio Inaspettato";
  return "Titolo Sconosciuto";
};

const BookingList = ({ bookings, onBookingClick, title }) => {
  const calculateNights = (startDate, endDate) => {
    const start = new Date(startDate.seconds * 1000);
    const end = new Date(endDate.seconds * 1000);
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    return Math.ceil((end - start) / millisecondsPerDay);
  };
  return (
    <Box display={bookings.length > 0 ? "block" : "none"}>
      <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
        {bookings.map((booking) => (
          <li key={booking.id}>
            <Stack
              spacing={1}
              onClick={(e) => onBookingClick(e, booking)}
              sx={{
                flexDirection: "column",
                padding: "20px",
                cursor: "pointer",
                color: "white",
                mb: 2,
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                borderRadius: "16px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-3px)",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  boxShadow: "0 8px 25px rgba(0, 0, 0, 0.3)",
                },
              }}
            >
              <Box>
                {title === "Check-in" && (
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      background:
                        "linear-gradient(135deg, #ab9501 0%, #d4af37 100%)",
                      color: "white",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      boxShadow: "0 4px 12px rgba(171, 149, 1, 0.3)",
                    }}
                    variant="body2"
                  >
                    <LoginIcon fontSize="small" sx={{ marginRight: "5px" }} />
                    Check-In
                  </Typography>
                )}
                {title === "In corso" && (
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      background:
                        "linear-gradient(135deg, #6d6d6d 0%, #8a8a8a 100%)",
                      color: "white",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      boxShadow: "0 4px 12px rgba(109, 109, 109, 0.3)",
                    }}
                    variant="body2"
                  >
                    <LoginIcon fontSize="small" sx={{ marginRight: "5px" }} />
                    In corso
                  </Typography>
                )}
                {title === "Check-out" && (
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      background:
                        "linear-gradient(135deg, #ff3939 0%, #ff6b6b 100%)",
                      color: "white",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      boxShadow: "0 4px 12px rgba(255, 57, 57, 0.3)",
                    }}
                    variant="body2"
                  >
                    <LogoutIcon fontSize="small" sx={{ marginRight: "5px" }} />
                    Check-Out
                  </Typography>
                )}
              </Box>
              <Typography
                sx={{
                  color: "#e0e0e0",
                  fontSize: "16px",
                  fontWeight: "500",
                  opacity: 0.9,
                  mb: 1,
                }}
              >
                {getRoomTitle(booking.roomId)}
              </Typography>
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    letterSpacing: 1,
                    fontWeight: "700",
                    color: "white",
                    fontSize: "1.4rem",
                    mb: 1,
                  }}
                >
                  {booking.customerName}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: "#e0e0e0",
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    mb: 1,
                  }}
                  variant="body1"
                >
                  <CalendarMonth sx={{ color: "#d4af37", fontSize: "20px" }} />
                  {formatBookingDates(
                    new Date(booking.startDate.seconds * 1000),
                    new Date(booking.endDate.seconds * 1000)
                  )}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: "#e0e0e0",
                  fontSize: "15px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  mb: 1,
                }}
                variant="body1"
              >
                <NightsStayIcon sx={{ color: "#8a8a8a", fontSize: "20px" }} />
                {calculateNights(booking.startDate, booking.endDate)} notti
              </Typography>
              <Typography
                sx={{
                  display:
                    booking.adultsCount == 0 && booking.childrenCount == 0
                      ? "none"
                      : "flex",
                  color: "#e0e0e0",
                  fontSize: "15px",
                  alignItems: "center",
                  gap: "10px",
                  mb: 2,
                }}
                variant="body1"
              >
                <PersonIcon sx={{ color: "#ff6b6b", fontSize: "20px" }} />{" "}
                {booking.adultsCount} ospiti totali
              </Typography>
              <Divider
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  height: "1px",
                  mt: 1,
                }}
              />
            </Stack>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default BookingList;
